// extracted by mini-css-extract-plugin
export default {"container":"AdressAutocompleteInput_container__2nh0u","localization":"AdressAutocompleteInput_localization__Gp58W"};